<template>
  <div id="admin">
    <AppNavbar />
    <AdminHeader />
    <div v-if="benutzer.admin !== 1">
      <b-aler variant="danger">Not Allowed</b-aler>
    </div>
    <div v-else class="m-2">
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Benutzer"  active>
            <div v-if="alleBenutzer !== null" class="text-left">
              <BenutzerTable @updateUserToast="makeToast"/>
            </div>
          </b-tab>

          <b-tab title="Sigfox Daten">
            <SigfoxTable />
          </b-tab>

          <b-tab title="Geräte">
            <b-row v-if="alleBenutzer && alleBenutzer.length > 0">
              <b-col cols="12" md="7">
                <Geraet />
              </b-col>
              <b-col cols="12" md="5">
                <Geraetetypen />
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppNavbar from '@/components/Nav/AppNavbar'
import AdminHeader from '../Content/AdminHeader'
import BenutzerTable from '../Content/BenutzerTable'
import SigfoxTable from '../Content/SigfoxTable'
import Geraet from '../Content/Geraet'
import Geraetetypen from '../Content/Geraetetypen'

export default {
  name: 'Admin',
  components: {
    AppNavbar,
    AdminHeader,
    BenutzerTable,
    SigfoxTable,
    Geraet,
    Geraetetypen
  },
  computed: mapGetters(['benutzer', 'alleBenutzer', 'benutzerStatus', 'sigfox']),
  methods: {
    ...mapActions(['getAllBenutzer', 'updateBenutzer', 'fetchAllSigfoxData', 'fetchAlleGeraete']),
    makeToast (toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: 'b-toaster-bottom-full',
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      })
    }
  },
  mounted () {
    this.getAllBenutzer()
    this.fetchAllSigfoxData()
    this.fetchAlleGeraete()
  }
}
</script>

<style>

</style>
